var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTerms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 105,
    viewBox: "0 0 182 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5027 96.1755C36.5027 96.1755 23.5493 84.726 23.7227 63.3846C23.9073 40.6656 45.3409 31.6676 71.1328 23.2909C87.6701 17.9196 99.9661 -4.22317 128.234 5.15079C145.161 10.7653 158.524 24.7722 158.623 50.4448C158.738 80.2033 137.14 96.1755 137.14 96.1755H36.5049",
    fill: "#D4F1EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.19043 96.1753H166.725",
    stroke: "#222557",
    strokeWidth: 1.35072,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6222 82.99C28.9365 82.99 34.866 77.0605 34.866 69.7462C34.866 62.4319 28.9365 56.5024 21.6222 56.5024C14.3079 56.5024 8.37842 62.4319 8.37842 69.7462C8.37842 77.0605 14.3079 82.99 21.6222 82.99Z",
    fill: "#B7F28F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.864 82.8707C20.4381 82.9495 21.0256 82.99 21.6222 82.99C28.9408 82.99 34.866 77.0648 34.866 69.7462C34.866 62.4343 28.9408 56.5024 21.6222 56.5024C21.0256 56.5024 20.4381 56.543 19.864 56.6218C26.3429 57.484 31.3428 63.0332 31.3428 69.7485C31.3428 76.4683 26.3407 82.0107 19.864 82.8752V82.8707Z",
    fill: "#51A915"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6221 69.0146V78.3008V91.8328",
    stroke: "#222557",
    strokeWidth: 1.12785,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0969 74.7012L21.6223 78.3008",
    stroke: "#222557",
    strokeWidth: 1.12785,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0056 71.7271L21.6221 75.1804",
    stroke: "#222557",
    strokeWidth: 1.12785,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.42067 64.591C8.74981 66.1758 8.38062 67.9182 8.38062 69.7462C8.38062 77.0603 14.3103 82.99 21.6244 82.99C28.9385 82.99 34.8682 77.0603 34.8682 69.7462C34.8682 62.4321 28.9385 56.5024 21.6244 56.5024C18.538 56.5024 15.6992 57.5583 13.4481 59.3277",
    stroke: "#222557",
    strokeWidth: 1.12785,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5908 103.345H46.9413",
    stroke: "#222557",
    strokeWidth: 1.35072,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M140.953 103.345H147.986",
    stroke: "#222557",
    strokeWidth: 1.35072,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M100.567 103.345H134.88",
    stroke: "#222557",
    strokeWidth: 1.35072,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8035 103.345H68.357C68.6384 101.141 70.5226 99.437 72.8031 99.437C75.07 99.437 76.9498 101.161 77.2492 103.345H92.8049",
    stroke: "#222557",
    strokeWidth: 1.35072,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.854 13.4283C45.5568 14.0406 45.3902 14.7295 45.3902 15.4566C45.3902 15.6367 45.4015 15.8123 45.4218 15.9857C44.9693 15.7358 44.4492 15.594 43.8977 15.594C42.135 15.594 40.7078 17.037 40.7078 18.8177C40.7078 20.5984 42.135 22.0414 43.8977 22.0414H55.246C57.2045 22.0414 58.7916 20.4363 58.7916 18.4575C58.7916 16.4787 57.2045 14.8736 55.246 14.8736C54.9848 14.8736 54.7305 14.9028 54.4873 14.9569C54.2397 12.6449 52.3037 10.8462 49.9534 10.8462C48.8638 10.8462 47.8643 11.2334 47.0786 11.8772",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.854 13.4283C45.5568 14.0406 45.3902 14.7295 45.3902 15.4566C45.3902 15.6367 45.4015 15.8123 45.4218 15.9857C44.9693 15.7358 44.4492 15.594 43.8977 15.594C42.135 15.594 40.7078 17.037 40.7078 18.8177C40.7078 20.5984 42.135 22.0414 43.8977 22.0414H55.246C57.2045 22.0414 58.7916 20.4363 58.7916 18.4575C58.7916 16.4787 57.2045 14.8736 55.246 14.8736C54.9848 14.8736 54.7305 14.9028 54.4873 14.9569C54.2397 12.6449 52.3037 10.8462 49.9534 10.8462C48.8638 10.8462 47.8643 11.2334 47.0786 11.8772",
    stroke: "#272252",
    strokeWidth: 0.871212,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0354 11.6656C48.0354 11.6656 52.1686 11.0352 53.373 15.4476C53.4833 15.855 53.857 16.1387 54.2802 16.1409C55.3585 16.1477 57.236 16.4043 57.3418 18.1175C57.4904 20.5285 56.304 21.0846 54.9511 21.8252L56.1757 22.0436L58.123 20.5533L58.8839 18.0995L58.2333 16.5304L56.6057 15.1504L54.825 14.8195L54.0641 13.7817L53.0623 11.7984L50.3744 10.8687H48.9291L48.0399 11.6678L48.0354 11.6656Z",
    fill: "#E2E3F2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M45.854 13.4283C45.5568 14.0406 45.3902 14.7295 45.3902 15.4566C45.3902 15.6367 45.4015 15.8123 45.4218 15.9857C44.9693 15.7358 44.4492 15.594 43.8977 15.594C42.135 15.594 40.7078 17.037 40.7078 18.8177C40.7078 20.5984 42.135 22.0414 43.8977 22.0414H55.246C57.2045 22.0414 58.7916 20.4363 58.7916 18.4575C58.7916 16.4787 57.2045 14.8736 55.246 14.8736C54.9848 14.8736 54.7305 14.9028 54.4873 14.9569C54.2397 12.6449 52.3037 10.8462 49.9534 10.8462C48.8638 10.8462 47.8643 11.2334 47.0786 11.8772",
    stroke: "#222557",
    strokeWidth: 0.871212,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5964 25.7014C28.1754 26.5703 27.9391 27.5451 27.9391 28.5761C27.9391 28.8305 27.9526 29.0804 27.9818 29.328C27.3402 28.9746 26.6019 28.772 25.8207 28.772C23.3241 28.772 21.3003 30.8183 21.3003 33.3419C21.3003 35.8655 23.3241 37.9118 25.8207 37.9118H41.9032C44.6767 37.9118 46.9279 35.6381 46.9279 32.8331C46.9279 30.0281 44.6789 27.7544 41.9032 27.7544C41.5318 27.7544 41.1716 27.795 40.8271 27.8715C40.4782 24.5938 37.734 22.0454 34.4022 22.0454C32.8579 22.0454 31.4397 22.5925 30.3298 23.5064",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5964 25.7014C28.1754 26.5703 27.9391 27.5451 27.9391 28.5761C27.9391 28.8305 27.9526 29.0804 27.9818 29.328C27.3402 28.9746 26.6019 28.772 25.8207 28.772C23.3241 28.772 21.3003 30.8183 21.3003 33.3419C21.3003 35.8655 23.3241 37.9118 25.8207 37.9118H41.9032C44.6767 37.9118 46.9279 35.6381 46.9279 32.8331C46.9279 30.0281 44.6789 27.7544 41.9032 27.7544C41.5318 27.7544 41.1716 27.795 40.8271 27.8715C40.4782 24.5938 37.734 22.0454 34.4022 22.0454C32.8579 22.0454 31.4397 22.5925 30.3298 23.5064",
    stroke: "#272252",
    strokeWidth: 1.2359,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6897 23.2025C31.6897 23.2025 37.5473 22.3087 39.2537 28.5626C39.4113 29.1411 39.9403 29.5396 40.5414 29.5441C42.0699 29.5531 44.7309 29.9178 44.8817 32.3468C45.091 35.7619 43.4094 36.5498 41.4914 37.6011L43.2248 37.9118L45.9848 35.7979L47.0631 32.3198L46.1401 30.0956L43.8326 28.1393L41.309 27.6688L40.2307 26.1966L38.8125 23.3848L35.0035 22.0679H32.9549L31.6942 23.2002L31.6897 23.2025Z",
    fill: "#E2E3F2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5964 25.7014C28.1754 26.5703 27.9391 27.5451 27.9391 28.5761C27.9391 28.8305 27.9526 29.0804 27.9818 29.328C27.3402 28.9746 26.6019 28.772 25.8207 28.772C23.3241 28.772 21.3003 30.8183 21.3003 33.3419C21.3003 35.8655 23.3241 37.9118 25.8207 37.9118H41.9032C44.6767 37.9118 46.9279 35.6381 46.9279 32.8331C46.9279 30.0281 44.6789 27.7544 41.9032 27.7544C41.5318 27.7544 41.1716 27.795 40.8271 27.8715C40.4782 24.5938 37.734 22.0454 34.4022 22.0454C32.8579 22.0454 31.4397 22.5925 30.3298 23.5064",
    stroke: "#222557",
    strokeWidth: 1.2359,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M113.507 58.0308H117.719V31.98H113.507V58.0308Z",
    fill: "#D4F1EF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M160.557 34.8482C160.091 35.8072 159.83 36.8855 159.83 38.0246C159.83 38.306 159.845 38.5807 159.877 38.8553C159.168 38.4636 158.353 38.2408 157.491 38.2408C154.733 38.2408 152.498 40.501 152.498 43.2879C152.498 46.0749 154.733 48.3351 157.491 48.3351H175.255C178.319 48.3351 180.804 45.8228 180.804 42.7251C180.804 39.6275 178.319 37.1152 175.255 37.1152C174.845 37.1152 174.447 37.1602 174.066 37.2457C173.679 33.6258 170.649 30.8096 166.968 30.8096C165.262 30.8096 163.697 31.4151 162.468 32.4237",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M160.557 34.8482C160.091 35.8072 159.83 36.8855 159.83 38.0246C159.83 38.306 159.845 38.5807 159.877 38.8553C159.168 38.4636 158.353 38.2408 157.491 38.2408C154.733 38.2408 152.498 40.501 152.498 43.2879C152.498 46.0749 154.733 48.3351 157.491 48.3351H175.255C178.319 48.3351 180.804 45.8228 180.804 42.7251C180.804 39.6275 178.319 37.1152 175.255 37.1152C174.845 37.1152 174.447 37.1602 174.066 37.2457C173.679 33.6258 170.649 30.8096 166.968 30.8096C165.262 30.8096 163.697 31.4151 162.468 32.4237",
    stroke: "#272252",
    strokeWidth: 1.36422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M163.972 32.0881C163.972 32.0881 170.442 31.0998 172.326 38.0087C172.499 38.6481 173.085 39.0893 173.747 39.0915C175.435 39.1006 178.375 39.5058 178.539 42.1869C178.771 45.9599 176.914 46.8311 174.796 47.9905L176.711 48.3327L179.76 45.9982L180.95 42.1554L179.931 39.6994L177.382 37.5382L174.595 37.0205L173.404 35.3951L171.838 32.2907L167.63 30.8364H165.365L163.972 32.0881Z",
    fill: "#E2E3F2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M160.557 34.8482C160.091 35.8072 159.83 36.8855 159.83 38.0246C159.83 38.306 159.845 38.5807 159.877 38.8553C159.168 38.4636 158.353 38.2408 157.491 38.2408C154.733 38.2408 152.498 40.501 152.498 43.2879C152.498 46.0749 154.733 48.3351 157.491 48.3351H175.255C178.319 48.3351 180.804 45.8228 180.804 42.7251C180.804 39.6275 178.319 37.1152 175.255 37.1152C174.845 37.1152 174.447 37.1602 174.066 37.2457C173.679 33.6258 170.649 30.8096 166.968 30.8096C165.262 30.8096 163.697 31.4151 162.468 32.4237",
    stroke: "#222557",
    strokeWidth: 1.36422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M69.845 64.4042L72.9719 67.646L78.9826 61.5092L76.0155 58.6997L69.845 64.3074",
    fill: "#8B8B8B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M120.224 20.8885L122.525 22.7615L124.148 25.7893L126.692 33.8778L126.895 40.4018L124.616 48.864L120.839 54.9535L116.028 59.7305L107.818 63.6949L103.696 64.6719L97.5459 64.8025L90.5514 63.3527L83.5254 59.5752L77.8119 53.6095L74.4396 47.6777L72.8841 41.2775L72.6274 37.0002L73.1272 32.5654L74.6265 27.6623L76.2181 24.353L78.7484 21.1991L75.6012 18.2231L73.6112 20.2018L70.1308 28.1621L68.6946 34.8143V41.0591L69.4645 45.1788L71.3487 50.7055L72.812 53.3912L75.4076 57.1394L80.1532 61.8849L84.0882 64.5391L90.3646 67.2248L95.7021 68.4427H103.01L109.846 66.725L114.563 64.5076L118.903 61.5405L122.93 57.5762L125.584 53.7671L127.863 49.1454L129.425 44.3324L130.049 39.0286L129.893 34.0332L128.738 28.8194L126.366 23.1352L123.232 18.1353L120.224 20.8885Z",
    fill: "#8B8B8B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6385 56.2097V12.262C82.6385 11.2782 83.3454 10.479 84.2143 10.479H114.45C115.321 10.479 116.026 11.2759 116.026 12.262V56.2097C107.348 64.6652 92.618 65.1312 82.6362 56.2097",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M113.302 42.0903C106.661 48.5738 93.0637 48.3599 85.7654 42.0903Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7678 7.88784V5.84601C85.7678 5.03332 86.3509 4.37598 87.069 4.37598H112.003C112.721 4.37598 113.304 5.03332 113.304 5.84601V7.88784",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4627 72.1506L59.7867 87.9945C58.2041 89.8292 55.3946 89.926 53.6882 88.2061L49.1048 83.5529C47.5515 81.8083 47.7383 79.1271 49.519 77.6165L65.4147 64.1049C66.4795 63.2021 68.0599 63.2629 69.0504 64.2467L73.3209 68.4834C74.3249 69.4785 74.3857 71.0813 73.4627 72.1506Z",
    fill: "#C23436"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7081 56.6238C96.1334 56.6238 98.9102 53.8471 98.9102 50.4218C98.9102 46.9965 96.1334 44.2197 92.7081 44.2197C89.2828 44.2197 86.5061 46.9965 86.5061 50.4218C86.5061 53.8471 89.2828 56.6238 92.7081 56.6238Z",
    fill: "#61D215"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M117.6 26.0548V10.8548C117.6 9.90926 116.832 9.1416 115.886 9.1416H83.0596C82.1141 9.1416 81.3464 9.90926 81.3464 10.8548V53.0759",
    stroke: "#222557",
    strokeWidth: 1.46778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M117.6 31.368V27.7256",
    stroke: "#222557",
    strokeWidth: 1.46778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M117.6 53.0762V34.3418",
    stroke: "#222557",
    strokeWidth: 1.46778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1762 3.03857H86.0402C85.2658 3.28395 84.6355 3.91204 84.6355 4.68645V7.26406",
    stroke: "#222557",
    strokeWidth: 1.46778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0003 3.03857H91.9585",
    stroke: "#222557",
    strokeWidth: 1.46778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M114.362 7.26651V4.68889C114.362 3.91448 113.734 3.28414 112.958 3.04102H96.2944",
    stroke: "#222557",
    strokeWidth: 1.46778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M121.852 8.61056L124.709 7.82715",
    stroke: "#222557",
    strokeWidth: 1.46778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M126.859 7.20821L127.962 6.9043",
    stroke: "#222557",
    strokeWidth: 1.46778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M119.659 5.14825L123.25 1.6499",
    stroke: "#222557",
    strokeWidth: 1.46778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M106.078 17.856H92.7126",
    stroke: "#222557",
    strokeWidth: 1.46778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M111.323 27.0342H87.76",
    stroke: "#222557",
    strokeWidth: 1.46778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M111.323 34.3418H104.162",
    stroke: "#222557",
    strokeWidth: 1.46778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M87.76 34.3418H101.582",
    stroke: "#222557",
    strokeWidth: 1.46778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M111.323 44.3325H100.25",
    stroke: "#222557",
    strokeWidth: 1.46778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M109.534 50.3276H103.829",
    stroke: "#222557",
    strokeWidth: 1.46778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M111.323 56.5112H100.25",
    stroke: "#222557",
    strokeWidth: 1.46778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4537 14.959C72.2494 20.623 68.3594 28.7768 68.3594 37.8379C68.3594 54.9447 82.2267 68.8121 99.3335 68.8121C116.44 68.8121 130.308 54.9447 130.308 37.8379C130.308 28.7431 126.386 20.5622 120.144 14.896",
    stroke: "#222557",
    strokeWidth: 1.46778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M120.693 20.8301C124.446 25.454 126.692 31.3499 126.692 37.7681C126.692 52.6259 114.646 64.6721 99.7883 64.6721C84.9304 64.6721 72.8843 52.6259 72.8843 37.7681C72.8843 31.5975 74.9621 25.9133 78.4537 21.3749",
    stroke: "#222557",
    strokeWidth: 1.46778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7351 56.6982C96.2014 56.6982 99.0114 53.8882 99.0114 50.4218C99.0114 46.9555 96.2014 44.1455 92.7351 44.1455C89.2687 44.1455 86.4587 46.9555 86.4587 50.4218C86.4587 53.8882 89.2687 56.6982 92.7351 56.6982Z",
    stroke: "#222557",
    strokeWidth: 1.46778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2363 50.1401L91.8594 51.8263L95.3578 48.6724",
    stroke: "#222557",
    strokeWidth: 1.46778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8865 68.0958L79.3542 61.5088",
    stroke: "#222557",
    strokeWidth: 1.46778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4646 64.665L76.1596 58.3887",
    stroke: "#222557",
    strokeWidth: 1.46778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4627 72.1506L59.7867 87.9945C58.2041 89.8292 55.3946 89.926 53.6882 88.2061L49.1048 83.5529C47.5515 81.8083 47.7383 79.1271 49.519 77.6165L65.4147 64.1049C66.4795 63.2021 68.0599 63.2629 69.0504 64.2467L73.3209 68.4834C74.3249 69.4785 74.3857 71.0813 73.4627 72.1506Z",
    stroke: "#222557",
    strokeWidth: 1.46778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M129.472 93.895C129.472 94.5974 129.61 95.2682 129.857 95.8828H157.68C157.693 95.7702 157.698 95.6532 157.698 95.5339C157.698 93.366 155.94 91.6055 153.77 91.6055C153.286 91.6055 152.82 91.6933 152.39 91.8599C152.128 89.9014 150.445 88.3931 148.419 88.3931C146.622 88.3931 145.1 89.5749 144.591 91.2026C143.864 90.3944 142.802 89.8856 141.627 89.8856C140.67 89.8856 139.787 90.221 139.096 90.7861C138.133 89.4444 136.561 88.5732 134.79 88.5732C131.85 88.5732 129.47 90.9527 129.47 93.8927L129.472 93.895Z",
    fill: "#F4665A",
    stroke: "#222557",
    strokeWidth: 1.24266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M139.207 95.2752H151.962C151.462 93.7601 150.033 92.666 148.349 92.666C146.665 92.666 145.357 93.6678 144.801 95.0838C144.202 94.2126 143.198 93.643 142.063 93.643C140.848 93.643 139.783 94.2981 139.207 95.2752Z",
    fill: "#B91618"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M131.508 95.275H139.15C138.693 93.5933 137.156 92.3574 135.33 92.3574C133.504 92.3574 131.967 93.5933 131.508 95.275Z",
    fill: "#B91618"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5959 94.5004C29.5959 94.9889 29.6905 95.4571 29.8638 95.8849H49.2241C49.2331 95.8061 49.2376 95.725 49.2376 95.6417C49.2376 94.1334 48.013 92.9088 46.5047 92.9088C46.167 92.9088 45.8428 92.9695 45.5457 93.0866C45.3633 91.7246 44.1927 90.6733 42.7812 90.6733C41.5318 90.6733 40.4715 91.495 40.118 92.6274C39.6115 92.0646 38.8731 91.7111 38.0559 91.7111C37.3896 91.7111 36.775 91.9453 36.2955 92.3392C35.6246 91.405 34.5306 90.7994 33.2992 90.7994C31.2528 90.7994 29.5982 92.4563 29.5982 94.5004H29.5959Z",
    fill: "#F4665A",
    stroke: "#222557",
    strokeWidth: 0.864458,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3699 95.4593H45.2463C44.8996 94.4057 43.9046 93.6426 42.7317 93.6426C41.5589 93.6426 40.6494 94.3404 40.2622 95.3242C39.8457 94.7186 39.1478 94.3224 38.3577 94.3224C37.5112 94.3224 36.7706 94.7772 36.3699 95.4593Z",
    fill: "#B91618"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M31.012 95.4593H36.3315C36.0141 94.2887 34.9425 93.4287 33.6729 93.4287C32.4032 93.4287 31.3316 94.2887 31.012 95.4593Z",
    fill: "#B91618"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7372 93.895C35.7372 94.5974 35.5999 95.2682 35.3522 95.8828H7.52973C7.51622 95.7702 7.51172 95.6532 7.51172 95.5339C7.51172 93.366 9.2699 91.6055 11.4401 91.6055C11.9241 91.6055 12.3901 91.6933 12.82 91.8599C13.0812 89.9014 14.7651 88.3931 16.7911 88.3931C18.5876 88.3931 20.1094 89.5749 20.6182 91.2026C21.3453 90.3944 22.4079 89.8856 23.583 89.8856C24.5397 89.8856 25.4222 90.221 26.1133 90.7861C27.0768 89.4444 28.6482 88.5732 30.4199 88.5732C33.3599 88.5732 35.7394 90.9527 35.7394 93.8927L35.7372 93.895Z",
    fill: "#F4665A",
    stroke: "#222557",
    strokeWidth: 1.24266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0006 95.2752H13.2454C13.7451 93.7601 15.1746 92.666 16.8585 92.666C18.4726 92.666 19.8504 93.6678 20.4064 95.0838C21.0052 94.2126 22.0093 93.643 23.1439 93.643C24.3595 93.643 25.4243 94.2981 26.0006 95.2752Z",
    fill: "#B91618"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6999 95.275H26.0571C26.5141 93.5933 28.0517 92.3574 29.8774 92.3574C31.7031 92.3574 33.2407 93.5933 33.6999 95.275Z",
    fill: "#B91618"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M154.961 91.7359V71.1577C154.961 69.5076 156.3 68.1681 157.95 68.1681H167.615C169.265 68.1681 170.604 66.8287 170.604 65.1786V57.5312",
    stroke: "#222557",
    strokeWidth: 1.12785,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M154.961 73.0351H151.415C149.765 73.0351 148.425 71.6956 148.425 70.0455V66.2568V49.7803",
    stroke: "#222557",
    strokeWidth: 1.12785,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M156.352 62.4341V63.4764C156.352 65.1265 155.012 66.466 153.362 66.466H148.425",
    stroke: "#222557",
    strokeWidth: 1.12785,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M148.425 60.9032H142.343C140.692 60.9032 139.353 59.5637 139.353 57.9136",
    stroke: "#222557",
    strokeWidth: 1.12785,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M154.961 78.3187H144.427C142.777 78.3187 141.438 76.9792 141.438 75.3291V73.0352",
    stroke: "#222557",
    strokeWidth: 1.12785,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M148.425 34.5059V50.4601H151.536C155.604 50.4601 158.146 46.0567 156.111 42.5359L153 37.1443C151.982 35.3838 150.201 34.5059 148.425 34.5059Z",
    fill: "#51A915"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M145.312 50.4581H148.423V34.5039C146.647 34.5039 144.866 35.3819 143.849 37.1423L140.738 42.5339C138.707 46.0548 141.249 50.4581 145.312 50.4581Z",
    fill: "#B7F28F"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M139.353 50.3047V57.916H140.839C142.779 57.916 143.99 55.8156 143.02 54.1362L141.534 51.5654C141.048 50.7257 140.199 50.3069 139.353 50.3069V50.3047Z",
    fill: "#51A915"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M137.87 57.916H139.355V50.3047C138.509 50.3047 137.658 50.7234 137.174 51.5631L135.688 54.134C134.72 55.8134 135.931 57.9137 137.87 57.9137V57.916Z",
    fill: "#B7F28F"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M141.44 63.8618V73.6275H143.344C145.834 73.6275 147.39 70.9328 146.145 68.7762L144.24 65.4759C143.617 64.3976 142.527 63.8618 141.44 63.8618Z",
    fill: "#51A915"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M139.533 73.6275H141.438V63.8618C140.35 63.8618 139.261 64.3999 138.637 65.4759L136.733 68.7762C135.49 70.9306 137.046 73.6275 139.533 73.6275Z",
    fill: "#B7F28F"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M156.352 52.6504V62.4161H158.256C160.746 62.4161 162.302 59.7214 161.057 57.5647L159.152 54.2645C158.529 53.1862 157.439 52.6504 156.352 52.6504Z",
    fill: "#51A915"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M154.445 62.4161H156.349V52.6504C155.262 52.6504 154.173 53.1884 153.549 54.2645L151.645 57.5647C150.402 59.7191 151.957 62.4161 154.445 62.4161Z",
    fill: "#B7F28F"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M170.602 45.5415V57.9141H173.015C176.169 57.9141 178.141 54.499 176.563 51.7683L174.15 47.5878C173.362 46.2236 171.98 45.5415 170.602 45.5415Z",
    fill: "#51A915"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M168.189 57.916H170.602V45.5435C169.224 45.5435 167.842 46.2256 167.054 47.5898L164.641 51.7703C163.067 54.501 165.037 57.916 168.189 57.916Z",
    fill: "#B7F28F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerms);
export default __webpack_public_path__ + "static/media/terms.da50a8921c65229cec6ef0ccabf08714.svg";
export { ForwardRef as ReactComponent };